import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { InvoiceSteps } from 'constants/payment';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setStep } from 'store/payment/slice';
import type { HeaderProps } from 'types';

import { HeaderConfigSZ } from './constants';

const HeaderSZ: FC<HeaderProps> = ({ children, showBackArray = true }) => {
  const { step } = useAppSelector((state) => state.payment);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const back = () => {
    if (step === InvoiceSteps.ENTER_AMOUNT) {
      navigate('/');
    } else {
      dispatch(setStep(InvoiceSteps.ENTER_AMOUNT));
    }
  };

  return (
    <header className="text-black relative flex min-h-7 w-full items-center justify-center gap-16 md:min-h-[46px]">
      {showBackArray && (
        <button
          type="button"
          onClick={back}
          className="absolute left-5 flex items-center gap-2.5 text-sm text-skin-bread-crumbs md:left-0"
        >
          <div className="h-3.5 w-3.5 bg-arrow-left md:h-4 md:w-4" />
          <div className="hidden sm:block">{HeaderConfigSZ.TEXT_BACK}</div>
        </button>
      )}
      <h2 className="px-4 py-5 text-xl">{children}</h2>
    </header>
  );
};

export { HeaderSZ };
